import { createAsyncThunk } from "@reduxjs/toolkit";
import { EymemoryLoginActions, EymemoryLoginPersistActions } from "./EymemoryLoginSlice";
import { EymemoryLoginStorageData, OrderDetails, RootState, ValidateOrderResponse } from "src/shared/types/src";
import { getEymemoryLoginStoreData } from "src/shared/utils/src";
import { validateEymemoriesSession } from "src/shared/services/src";

export const updateEymemoryLoginStatus = createAsyncThunk(
    "updateEymemoryLoginStatus", async ({ orderHash, isLoggedIn }: { orderHash: string, isLoggedIn: boolean }, { dispatch }) => {
        await dispatch(EymemoryLoginActions.setIsLoggedIn({orderHash , isLoggedIn}));
    }
);

export const updateEymemoryLoginData = createAsyncThunk(
    "updateEymemoryLoginData", async ({ loginData }: { loginData: EymemoryLoginStorageData }, { dispatch }) => {
        await dispatch(EymemoryLoginPersistActions.setLoginData(loginData));
    }
)

export const updateEymemoryOrderDetails = createAsyncThunk(
    "updateEymemoryOrderDetails", async ({orderHash, order }: { orderHash: string, order: OrderDetails }, { dispatch }) => {
        await dispatch(EymemoryLoginActions.setOrderDetails({orderHash, orderDetails: order}));
    }
);

export const performAfterLoginEymemoriesOrder = createAsyncThunk(
    "performAfterLoginEymemoriesOrder", async ({validateOrderResponse, orderHash }: {
        validateOrderResponse: ValidateOrderResponse,
        orderHash: string
    }, { dispatch }) => {
        const dataToStore: EymemoryLoginStorageData | undefined = getEymemoryLoginStoreData(validateOrderResponse, orderHash);
        try {
            if(dataToStore) {
                await dispatch(updateEymemoryLoginData({ loginData: dataToStore }));
                if (dataToStore?.accessToken) {
                    await dispatch(updateEymemoryLoginStatus({ orderHash, isLoggedIn: true }));
                }
                if (validateOrderResponse?.order) {
                    await dispatch(updateEymemoryOrderDetails({ orderHash, order: validateOrderResponse?.order }));
                }
                if (validateOrderResponse?.child?.dob) {
                    await dispatch(EymemoryLoginActions.setChild({ orderHash, child: validateOrderResponse?.child}));
                }
                if (validateOrderResponse?.nursery) {
                    await dispatch(EymemoryLoginActions.setNursery({orderHash, nursery: validateOrderResponse?.nursery}));
                }
            }

        } catch (error) {
            console.log("error in performAfterLoginEymemoriesOrder : ", error);
        }
    }
)

export const validateEymemoriesLoginTokens = createAsyncThunk(
    "validateEymemoriesLoginTokens", async ({ orderHash, reduxStore }: { orderHash: string, reduxStore: any }, { dispatch }) => {
        try {
            if(!orderHash) return false;
            const loginState = (reduxStore.getState() as RootState)?.eymemoryPersistLogin;
            if(!loginState?.[orderHash]?.loginData?.accessToken) return false;
            await dispatch(EymemoryLoginActions.setAuthLoading({orderHash, isAuthLoading: true}));
            const response = await validateEymemoriesSession({
                accessToken: loginState[orderHash].loginData.accessToken
            });
            if (response && Object.keys(response).length) {
                await dispatch(performAfterLoginEymemoriesOrder({
                    validateOrderResponse: response,
                    orderHash
                 }));
                return true;
            }
            return false;
        } catch (error: any) {
            console.log("error in validateLoginTokens : ", error);
            if (error && (error?.message === 'Network Error' || error?.code === 'ECONNABORTED')) {
                return true;
            }
            return false;
        } finally {
            await dispatch(EymemoryLoginActions.setAuthLoading({orderHash, isAuthLoading: false}));
        }
    }
)

export const eymemoryLogout = createAsyncThunk(
    "eymemoryLogout", async ({orderHash}: {orderHash?: string}, { dispatch }) => {
        try {
            if(orderHash){
                await dispatch(EymemoryLoginActions.setAuthLoading({orderHash, isAuthLoading: true}));
                await dispatch(EymemoryLoginActions.resetLoginState({orderHash}));
                await dispatch(EymemoryLoginPersistActions.resetPersistLoginState({orderHash}));
                // reset all states to initial state
                await dispatch(EymemoryLoginActions.setIsLoggedIn({orderHash, isLoggedIn:false}));
            } else {
                await dispatch(EymemoryLoginActions.resetLoginState({}));
                await dispatch(EymemoryLoginPersistActions.resetPersistLoginState({}));
            }
        } catch (error) {
            console.log("error in logout : ", error, (error as any).response);
        } finally {
            if(orderHash) {
                await dispatch(EymemoryLoginActions.setAuthLoading({orderHash, isAuthLoading: false}));
            }
        }
    }
)